import {
  GET_SHIPMENTMETHOD,
  GET_SHIPMENTMETHOD_SUCCESS,
  GET_SHIPMENTMETHOD_FAIL,
  DELETE_SHIPMENTMETHOD,
  DELETE_SHIPMENTMETHOD_SUCCESS,
  DELETE_SHIPMENTMETHOD_FAIL,
  UPDATE_SHIPMENTMETHOD,
  UPDATE_SHIPMENTMETHOD_SUCCESS,
  UPDATE_SHIPMENTMETHOD_FAIL,
  ADD_NEW_SHIPMENTMETHOD,
  ADD_SHIPMENTMETHOD_SUCCESS,
  ADD_SHIPMENTMETHOD_FAIL,
  SHIPMENTMETHOD_LOADING,
  SHIPMENTMETHOD_RESET,
} from "./actionType";

export const resetShipmentMethodState = (actionType) => ({
  type: SHIPMENTMETHOD_RESET,
  payload: { actionType },
});

export const getShipmentMethodSuccess = (actionType, data) => ({
  type: GET_SHIPMENTMETHOD_SUCCESS,
  payload: { actionType, data },
});

export const getShipmentMethodFail = (actionType, error) => ({
  type: GET_SHIPMENTMETHOD_FAIL,
  payload: { actionType, error },
});

export const getShipmentMethod = data => ({
  type: GET_SHIPMENTMETHOD,
  payload: data,
});

export const getShipmentMethodLoading = () => ({
  type: SHIPMENTMETHOD_LOADING
});

export const deleteShipmentMethod = data => ({
  type: DELETE_SHIPMENTMETHOD,
  payload: data,
});

export const deleteShipmentMethodSuccess = data => ({
  type: DELETE_SHIPMENTMETHOD_SUCCESS,
  payload: data,
});

export const deleteShipmentMethodFail = error => ({
  type: DELETE_SHIPMENTMETHOD_FAIL,
  payload: error,
});

export const updateShipmentMethod = data => ({
  type: UPDATE_SHIPMENTMETHOD,
  payload: data,
});

export const updateShipmentMethodFail = error => ({
  type: UPDATE_SHIPMENTMETHOD_FAIL,
  payload: error,
});

export const updateShipmentMethodSuccess = data => ({
  type: UPDATE_SHIPMENTMETHOD_SUCCESS,
  payload: data,
});

export const addNewShipmentMethod = data => ({
  type: ADD_NEW_SHIPMENTMETHOD,
  payload: data,
});

export const addShipmentMethodSuccess = data => ({
  type: ADD_SHIPMENTMETHOD_SUCCESS,
  payload: data,
});

export const addShipmentMethodFail = error => ({
  type: ADD_SHIPMENTMETHOD_FAIL,
  payload: error,
});